var fn = function() {
	/**
	 * Helper for implementing retries with backoff. Initial retry
	 * delay is 1 second, increasing by 2x (+jitter) for subsequent retries
	 *
	 * @constructor
	 */
	var RetryHandler = function(maxAttempts) {
		this.interval = 1000; // Start at one second
		this.maxInterval = 25 * 1000; // Don't wait longer than a minute
		this.maxAttempts = maxAttempts || 6;
		this.attempt = 0;
		this.timeoutId = null;
	};

	/**
	 * Invoke the function after waiting, or call `error` once attempts are exhausted.
	 *
	 * @param {function} fn - Function to invoke
	 * @param {function} error - Called instead of `fn` when out of attempts
	 */
	RetryHandler.prototype.retry = function(fn, error) {
		if (this.attempt >= this.maxAttempts) {
			error();
			return;
		}
		this.attempt += 1;
		this.cancel();
		this.timeoutId = setTimeout(fn, this.interval);
		this.interval = this.nextInterval_();
	};

	/**
	 * Cancel a pending retry so abort/cancel does not resume the upload later.
	 */
	RetryHandler.prototype.cancel = function() {
		if (this.timeoutId) {
			clearTimeout(this.timeoutId);
			this.timeoutId = null;
		}
	};

	/**
	 * Reset the counter (e.g. after successful request.)
	 */
	RetryHandler.prototype.reset = function() {
		this.cancel();
		this.interval = 1000;
		this.attempt = 0;
	};

	/**
	 * Calculate the next wait time.
	 * @return {number} Next wait interval, in milliseconds
	 *
	 * @private
	 */
	RetryHandler.prototype.nextInterval_ = function() {
		var interval = this.interval * 2 + this.getRandomInt_(0, 1000);
		return Math.min(interval, this.maxInterval);
	};

	/**
	 * Get a random int in the range of min to max. Used to add jitter to wait times.
	 *
	 * @param {number} min - Lower bounds
	 * @param {number} max - Upper bounds
	 * @private
	 */
	RetryHandler.prototype.getRandomInt_ = function(min, max) {
		return Math.floor(Math.random() * (max - min + 1) + min);
	};

	return RetryHandler;
};

export default fn();
